export const EDIT_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST =
  'EDIT_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST';
export const RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST =
  'RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_REQUEST';
export const RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS =
  'RESET_CLUB_MEMBER_VIRTUAL_SHIPMENT_ITEMS_SUCCESS';
export const EDIT_CLUB_MEMBER_SHIPMENT_ITEMS_REQUEST =
  'EDIT_CLUB_MEMBER_SHIPMENT_ITEMS_REQUEST';
export const GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS =
  'GET_CLUB_MEMBER_VIRTUAL_SHIPMENT_SUCCESS';

export const GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS =
  'GET_CLUB_MEMBER_SHIPMENT_SKIP_UNSKIP_SUCCESS';
export const GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST =
  'GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST';
export const GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS =
  'GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS';

export const PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST =
  'PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST';
export const SKIP_CLUB_MEMBER_SHIPMENT_REQUEST =
  'SKIP_CLUB_MEMBER_SHIPMENT_REQUEST';
export const UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST =
  'UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST';

export const GET_CLUB_MEMBER_SHIPMENT_SUCCESS =
  'GET_CLUB_MEMBER_SHIPMENT_SUCCESS';
export const LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS =
  'LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS';
